export const mantenimientoTitulo = "Página en Mantenimiento"

export const mantenimientoDescripcion = `
En este momento estamos trabajando en nuestra página web para poder 
seguir bindando el mejor servicio posible.
Le pedimos disculpas por cualquier molestia ocasionada.`;
